import { useRef, useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

// Store
import { lunaStore } from '@Store/luna';

// COMPONENTS
import { ScrollToTop } from '../UtilsComponents/ScrollTop';
import { Title2, ParagraphPlanet } from '@Components/Atomos/Titles';
import { SaberMas } from '@Components/Atomos/Buttons';

// Styles
import style from '@Sass/pages/general.module.scss';
import lunaStyle from '@Sass/pages/luna.module.scss';

// Nombra tu proyecto
export const NameProject = ({ handleNextPage, texts, setTitlePage }) => {
  const { dataLuna, setStateLuna, getLuna } = lunaStore(
    (state) => ({
      dataLuna: state.dataLuna,
      setStateLuna: state.setLuna,
      getLuna: state.getLuna,
    }),
    shallow
  );

  const handleNameProject = (event) => {
    setStateLuna({ ...dataLuna, nombre: event.target.value });
  };

  const projectName = useRef(null);

  useEffect(() => {
    projectName.current.focus();
    setTitlePage(texts?.titulo_de_la_vista);
  }, []);

  useEffect(() => {
    setTitlePage(texts.titulo_de_la_vista);
  }, [texts]);

  const handleVideo = () => {
    if (texts?.video) {
      return (
        <video controls>
          <source src={texts?.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
  };

  return (
    <>
      <ScrollToTop />
      <div className={lunaStyle.LaunchQuestion}>
        <p className={style.textCenter} dangerouslySetInnerHTML={{ __html: texts?.slogan }}></p>
        <div className={lunaStyle.video}>
        {handleVideo()}
        </div>
        <p
          className={style.textCenter}
          dangerouslySetInnerHTML={{ __html: texts?.descripcion }}
        ></p>

        <div className={lunaStyle.nameProjectContent}>
          <Title2 text={texts?.pregunta} />
          <input
            ref={projectName}
            type="text"
            name="projectName"
            id="projectName"
            className={lunaStyle.inputProjectName}
            placeholder="NOMBRE"
            value={getLuna().nombre}
            onChange={(e) => handleNameProject(e)}
          />

          <button
            type="button"
            className={getLuna().nombre.length <= 2 ? lunaStyle.btnPlanetOff : lunaStyle.btnPlanet}
            disabled={getLuna().nombre.length <= 2 ? 'disabled' : ''}
            onClick={() => handleNextPage(2)}
          >
            SIGUIENTE
          </button>
        </div>
      </div>
    </>
  );
};

// ¿Qué quieres hacer? WHAT
export const QuestionsLaunch1 = ({ handleNextPage, setPageLuna, texts2, setTitlePage }) => {
  const { dataLuna, setStateLuna, getLuna } = lunaStore(
    (state) => ({
      dataLuna: state.dataLuna,
      setStateLuna: state.setLuna,
      getLuna: state.getLuna,
    }),
    shallow
  );

  const Q1 = useRef(null);
  useEffect(() => {
    Q1.current.focus();
  }, []);

  const handleQuestion1 = (event) => {
    setStateLuna({
      ...dataLuna,
      que: event.target.value,
    });
  };

  useEffect(() => {
    setTitlePage(texts2.titulo_de_la_vista);
  }, [texts2]);

  return (
    <>
      <ScrollToTop />
      <p className={style.textCenter} dangerouslySetInnerHTML={{ __html: texts2?.slogan }}></p>
      <div className={lunaStyle.LaunchQuestion}>
        <Title2 text={texts2?.pregunta} />
        <ParagraphPlanet text={texts2?.descripcion} />
        <SaberMas data={texts2} />
        <label htmlFor="launchQ1" className={lunaStyle.labelPage}>
          1/3
        </label>
        <textarea
          ref={Q1}
          className={lunaStyle.response}
          name="what"
          id="launchQ1"
          cols="30"
          rows="10"
          placeholder="Escribe aquí tu idea"
          value={getLuna().que}
          onChange={(e) => handleQuestion1(e)}
        ></textarea>

        <div className={style.contentButtons}>
          <div className={style.flexButtons}>
            <button className={lunaStyle.btnPlanet} onClick={() => setPageLuna(1)}>
              REGRESAR
            </button>
            <button
              className={getLuna().que.length <= 12 ? lunaStyle.btnPlanetOff : lunaStyle.btnPlanet}
              type={'button'}
              disabled={getLuna().que.length <= 12 ? 'disabled' : ''}
              onClick={() => handleNextPage(3)}
            >
              SIGUIENTE
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

// ¿Por qué lo quieres hacer? WHY
export const QuestionsLaunch2 = ({ handleNextPage, setPageLuna, texts3 , setTitlePage}) => {
  const { dataLuna, setStateLuna, getLuna } = lunaStore(
    (state) => ({
      dataLuna: state.dataLuna,
      setStateLuna: state.setLuna,
      getLuna: state.getLuna,
    }),
    shallow
  );

  const Q2 = useRef(null);
  useEffect(() => {
    Q2.current.focus();
  }, []);

  const handleQuestion2 = (event) => {
    setStateLuna({ ...dataLuna, porque: event.target.value });
  };

  useEffect(() => {
    setTitlePage(texts3.titulo_de_la_vista);
  }, [texts3]);

  return (
    <>
      <ScrollToTop />
      <p className={style.textCenter} dangerouslySetInnerHTML={{ __html: texts3?.slogan }}></p>
      <div className={lunaStyle.LaunchQuestion}>
        <Title2 text={texts3?.pregunta} />
        <ParagraphPlanet text={texts3?.descripcion} />
        <SaberMas data={texts3} />
        <label htmlFor="launchQ1" className={lunaStyle.labelPage}>
          2/3
        </label>
        <textarea
          ref={Q2}
          className={lunaStyle.response}
          name="why"
          id="launchQ1"
          cols="30"
          rows="10"
          placeholder="Desarrolla tu idea"
          value={getLuna().porque}
          onChange={(e) => handleQuestion2(e)}
        ></textarea>

        <div className={style.contentButtons}>
          <div className={style.flexButtons}>
            <button className={lunaStyle.btnPlanet} onClick={() => setPageLuna(2)}>
              REGRESAR
            </button>
            <button
              className={
                getLuna().porque.length <= 12 ? lunaStyle.btnPlanetOff : lunaStyle.btnPlanet
              }
              type="button"
              disabled={getLuna().porque.length <= 12 ? 'disabled' : ''}
              onClick={() => handleNextPage(4)}
            >
              SIGUIENTE
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

// ¿Como lo quieres hacer? HOW
export const QuestionsLaunch3 = ({ handleNextPage, setPageLuna, texts4, setTitlePage }) => {
  const { dataLuna, setStateLuna, getLuna } = lunaStore(
    (state) => ({
      dataLuna: state.dataLuna,
      setStateLuna: state.setLuna,
      getLuna: state.getLuna,
    }),
    shallow
  );

  const Q3 = useRef(null);
  useEffect(() => {
    Q3.current.focus();
  }, []);

  const handleQuestion3 = (event) => {
    setStateLuna({ ...dataLuna, como: event.target.value });
  };

  useEffect(() => {
    setTitlePage(texts4.titulo_de_la_vista);
  }, [texts4]);

  return (
    <>
      <ScrollToTop />
      <p className={style.textCenter} dangerouslySetInnerHTML={{ __html: texts4?.slogan }}></p>
      <div className={lunaStyle.LaunchQuestion}>
        <Title2 text={texts4?.pregunta} />
        <ParagraphPlanet text={texts4?.descripcion} />
        <SaberMas data={texts4} />
        <label htmlFor="launchQ1" className={lunaStyle.labelPage}>
          3/3
        </label>
        <textarea
          ref={Q3}
          className={lunaStyle.response}
          name="how"
          id="launchQ1"
          cols="30"
          rows="10"
          placeholder="Describe tu planeación"
          value={getLuna().como}
          onChange={(e) => handleQuestion3(e)}
        ></textarea>

        <div className={style.contentButtons}>
          <div className={style.flexButtons}>
            <button className={lunaStyle.btnPlanet} onClick={() => setPageLuna(3)}>
              REGRESAR
            </button>
            <button
              className={getLuna().como.length <= 12 ? lunaStyle.btnPlanetOff : lunaStyle.btnPlanet}
              type={'button'}
              disabled={getLuna().como.length <= 12 ? 'disabled' : ''}
              onClick={() => handleNextPage(5)}
            >
              SIGUIENTE
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
